// Utility functions for vanilla JS
import slideDown from "@/scripts/helpers/slideDown.js";
import slideUp from "@/scripts/helpers/slideUp.js";
import loaded from '@/scripts/helpers/loaded';

// Mirror the open state on the toggles for assistive tech
function syncAria() {
    document.querySelectorAll('.js--megamenu__content, .js--megamenu__content--mobile').forEach(el => {
        el.setAttribute('aria-expanded', String(el.classList.contains('active--item')));
    });
    document.querySelectorAll('.js--mega__menu').forEach(el => {
        el.setAttribute('aria-expanded', String(el.classList.contains('active')));
    });
}

function closeMegamenu() {
    const body = document.querySelector('.body--parent--for__js');
    const megamenu = body?.querySelector('.header--megamenu--section');
    
    document.querySelectorAll('.js--mega__menu.active').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('.js--megamenu__content.active--item').forEach(el => el.classList.remove('active--item'));
    document.querySelectorAll('section.header--megamenu--section').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('.search--absolute--parent-form.active').forEach(el => el.classList.remove('active'));
    body?.classList.remove('active--header');
    megamenu?.classList.remove('active');
    syncAria();
}

loaded(() => {
    window.addEventListener('scroll', function () {
        var body = document.body,
            hasClassScrollEffect = body.classList.contains('scroll_bottom'),
            hasClassScrollActive = body.classList.contains('scroll__active');
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 0 && !hasClassScrollEffect) {
            body.classList.add('scroll_bottom');
        } else if (scrollTop == 0 && hasClassScrollEffect) {
            body.classList.remove('scroll_bottom');
        }
        
        if (!hasClassScrollActive) {
            body.classList.add('scroll__active');
        }
    });

    document.querySelectorAll('.js--slide--quick-links__parent').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var width = window.innerWidth,
                parent = this.closest('.parent__best-sellers_js'),
                content = parent.querySelector('.content--navigations__js'),
                hasClass = this.classList.contains('active--item');
            if (width < 768) {
                if (!hasClass) {
                    this.classList.add('active--item');
                    slideDown(content);
                } else {
                    this.classList.remove('active--item');
                    slideUp(content);
                }
            }
        });
    });
    document.querySelectorAll('.js--megamenu__content--mobile').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var parent = this.closest('.item--content--megamenu--section__parent'),
                content = parent.querySelector('.parent__item--content--inner__megamenu'),
                hasClass = this.classList.contains('active--item');

            if (!hasClass) {
                this.classList.add('active--item');
                content.classList.add('active');
            } else {
                this.classList.remove('active--item');
                content.classList.remove('active');
            }
            syncAria();
        });
    });
    document.querySelectorAll('.js--mega__menu').forEach(function(element) {
        element.addEventListener('click',  (event) => {
            event.preventDefault();

            const body = element.closest('.body--parent--for__js');
            const megamenu = body.querySelector('.header--megamenu--section');
            const search = body.querySelector('.search--absolute--parent-form');
            const hasClass = element.classList.contains('active');

            console.log('body', body);
            console.log('megamenu', megamenu);
            console.log('search', search);
            console.log('hasClass', hasClass);

            if (!hasClass) {
                element.classList.add('active');
                body.classList.add('active--header');
                megamenu.classList.add('active');
                search.classList.remove('active');
            } else {
                element.classList.remove('active');
                body.classList.remove('active--header');
                megamenu.classList.remove('active');
                search.classList.remove('active');
            }
            syncAria();
        });
    });
    document.querySelectorAll('.js--close__megamenu').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            closeMegamenu();
        });
    });
    document.querySelectorAll('.js--close__megamenu').forEach(function(element) {
        element.addEventListener('mouseenter', function () {
            closeMegamenu();
        });
    });
    document.querySelectorAll('.absolute__js__megamnu--off--click').forEach(function(element) {
        element.addEventListener('click', function () {
            closeMegamenu();
        });
    });
    document.querySelectorAll('.absolute__js__megamnu--off').forEach(function(element) {
        element.addEventListener('mouseenter', function () {
            closeMegamenu();
        });
    });

    document.querySelectorAll('.left--part--header__section').forEach(function(element) {
        element.addEventListener('mouseenter', function () {
            var body = document.querySelector('.body--parent--for__js'),
                megamenu = body?.querySelector('.header--megamenu--section'),
                height = window.innerHeight;
            if (height > 767) {
                document.querySelectorAll('.js--megamenu__content.active--item').forEach(el => el.classList.remove('active--item'));
                document.querySelectorAll('section.header--megamenu--section').forEach(el => el.classList.remove('active'));
                body?.classList.remove('active--header');
                megamenu?.classList.remove('active');
                syncAria();
            }
        });
    });
    document.querySelectorAll('.js--megamenu__content').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var id = this.getAttribute('data-id'),
                hasClass = this.classList.contains('active--item'),
                section = document.querySelector('section.header--megamenu--section'),
                item = section?.querySelector('.item--content--megamenu--section__parent[data-id="' + id + '"]'),
                body = this.closest('.body--parent--for__js'),
                megamenu = body?.querySelector('.header--megamenu--section'),
                hasClassJS = this.classList.contains('js--megamenu__content');
            if (!hasClass) {
                if (hasClassJS) {
                    document.querySelectorAll('.js--megamenu__content').forEach(el => el.classList.remove('active--item'));
                    document.querySelectorAll('.item--content--megamenu--section__parent').forEach(el => el.classList.remove('active'));
                    section?.classList.add('active');
                    this.classList.add('active--item');
                    item?.classList.add('active');
                    body?.classList.add('active--header');
                    megamenu?.classList.add('active');
                    // The panel fades in over 0.3s; focus once a link is really visible
                    const focusPanel = () => {
                        const link = [...(item?.querySelectorAll('a[href], button') || [])].find(el => el.getClientRects().length);
                        link?.focus();
                        return document.activeElement === link;
                    };
                    requestAnimationFrame(() => {
                        if (!focusPanel()) setTimeout(focusPanel, 350);
                    });
                } else {
                    document.querySelectorAll('.js--megamenu__content').forEach(el => el.classList.remove('active--item'));
                    section?.classList.remove('active');
                    body?.classList.remove('active--header');
                    megamenu?.classList.remove('active');
                }
            } else {
                if (hasClassJS) {
                    document.querySelectorAll('.js--megamenu__content').forEach(el => el.classList.remove('active--item'));
                    document.querySelectorAll('.item--content--megamenu--section__parent').forEach(el => el.classList.remove('active'));
                    section?.classList.remove('active');
                    this.classList.remove('active--item');
                    item?.classList.remove('active');
                    body?.classList.remove('active--header');
                    megamenu?.classList.remove('active');
                } else {
                    document.querySelectorAll('.js--megamenu__content').forEach(el => el.classList.remove('active--item'));
                    section?.classList.remove('active');
                    body?.classList.remove('active--header');
                    megamenu?.classList.remove('active');
                }
            }
            syncAria();
        });
    });
    document.querySelectorAll('.js--search__store').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var body = this.closest('.body--parent--for__js'),
                search = body?.querySelector('.search--absolute--parent-form'),
                input = body?.querySelector('input#boost-sd__search-widget-init-input-0'),
                megamenu = body?.querySelector('.header--megamenu--section'),
                hasClass = search?.classList.contains('active');
            if (!hasClass) {
                document.querySelectorAll('.js--mega__menu').forEach(el => el.classList.remove('active'));
                megamenu?.classList.remove('active');
                search?.classList.add('active');
                if (input) {
                    input.value = '';
                    input.focus();
                }
                document.querySelectorAll('.js--megamenu__content.active--item').forEach(el => el.classList.remove('active--item'));
                document.querySelectorAll('.item--content--megamenu--section__parent.active').forEach(el => el.classList.remove('active'));
            } else {
                search?.classList.remove('active');
            }
            syncAria();
        });
    });
    document.querySelectorAll('.close--search-js').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var body = this.closest('.body--parent--for__js'),
                search = body?.querySelector('.search--absolute--parent-form'),
                hasClass = search?.classList.contains('active');
            if (hasClass) {
                search?.classList.remove('active');
                body?.classList.remove('active--header');
            }
        });
    });
    document.querySelectorAll('.js__back--item--mobile').forEach(function(element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var parent = this.closest('.item--content--megamenu--section__parent'),
                content = this.closest('.parent__item--content--inner__megamenu'),
                btn = parent?.querySelector('.js--megamenu__content--mobile');
            content?.classList.remove('active');
            btn?.classList.remove('active--item');
            syncAria();
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        const opener = document.querySelector('.js--megamenu__content.active--item, .js--mega__menu.active');
        if (!opener && !document.querySelector('.search--absolute--parent-form.active')) return;
        closeMegamenu();
        opener?.focus();
    });
});
